import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import moment from "moment";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import concat from "lodash/concat";
import filter from "lodash/filter";
import compact from "lodash/compact";
import MaterialTable from "material-table";
import Button from "@material-ui/core/Button";
import TableHeader from "../Headers/TableHeader";
import {
  runReport,
  setReportLoading,
  setReportData,
} from "../../../Redux/Actions/reportActions";
import { getAgentInventory } from "../../../Utils/api";

import colors from "../../../Utils/colors";

class XfinityInventoryTable extends React.Component {
  async componentDidMount() {
    try {
      this.props.setReportLoading(true);
      await this.getData(false);
      this.props.setReportLoading(false);
    } catch (error) {
      this.props.setReportLoading(false);
    }
  }

  componentWillUnmount() {
    this.props.setReportData([]);
  }

  getData = async () => {
    const { agent } = this.props;
    try {
      this.props.setReportLoading(true);
      let agentId = agent.ID || null;
      const res = await getAgentInventory(agentId, false);
      if (res) this.props.setReportData(res);
      this.props.setReportLoading(false);
    } catch (error) {
      this.props.setReportLoading(false);
    }
  };

  goToOrderSection = () => {
    this.props.goToOrderTab();
  };

  render() {
    const { t, reportLoading, report } = this.props;
    const activatedInventory = compact(
      filter(report, (j) => {
        if (j?.activationDate) return j;
        return null;
      })
    );
    const sortedActivatedInv = orderBy(
      activatedInventory,
      ["activationDate"],
      ["desc"]
    );
    const notActivatedInventory = compact(
      filter(report, (j) => {
        if (!j?.activationDate) return j;
        return null;
      })
    );

    const mergedArray = concat(sortedActivatedInv, notActivatedInventory);

    const formattedData = map(mergedArray, (i) => {
      let activationDate = "";
      if (i.activationDate)
        activationDate = moment
          .utc(i.activationDate)
          .format("MM/DD/YYYY hh:mm:ss A");

      return {
        ...i,
        activationDate,
      };
    });

    return (
      <div>
        <Button
          variant="contained"
          // color="primary"
          size="large"
          //   className={classes.orderNowButton}
          style={{
            marginBottom: 10,
            color: "#fff",
            background: colors.bgGradient9,
          }}
          onClick={this.goToOrderSection}
        >
          {t("forms.orderEquipment")}
        </Button>
        <MaterialTable
          title={<TableHeader title="INVENTORY" />}
          columns={[
            {
              title: t("forms.activated"),
              field: "activationDate",
              cellStyle: { color: "#00457b" },
            },
            {
              title: t("forms.product"),
              field: "productName",
              cellStyle: { color: "#00457b" },
            },
            {
              title: "Serial Num",
              field: "serialNumber",
              cellStyle: { color: "#00457b" },
            },
            //   {
            //     title: "Carton Num",
            //     field: "cartonNumber",
            //     cellStyle: { color: "#00457b" },
            //   },
            //   {
            //     title: "Invoice",
            //     field: "invoice",
            //     cellStyle: { color: "#00457b" },
            //   },
          ]}
          data={formattedData}
          options={{
            search: true,
            rowStyle: (rowData) => ({
              backgroundColor:
                rowData.IsPaid === "Open" ||
                rowData.IsPaid === "Abierto" ||
                rowData.IsPaid === "Ouvert"
                  ? "#ffafaf"
                  : "#fff",
            }),
            headerStyle: {
              color: "#00457b",
            },
            emptyRowsWhenPaging: false,
            pageSizeOptions: [5, 10, 50, 100],
            exportButton: true,
            exportAllData: true,
            exportFileName: "XFINITY INVENTORY",
          }}
          localization={{
            body: {
              emptyDataSourceMessage: t("tables.noRecordsToDisplay"),
            },
            toolbar: {
              searchTooltip: t("tables.search"),
              searchPlaceholder: t("tables.search"),
              exportName: t("tables.exportCsv"),
            },
            pagination: {
              labelRowsSelect: t("tables.rows"),
              labelDisplayedRows: `{from}-{to} ${t("tables.of")} {count}`,
              firstTooltip: t("tables.firstPage"),
              previousTooltip: t("tables.previousPage"),
              nextTooltip: t("tables.nextPage"),
              lastTooltip: t("tables.lastPage"),
            },
          }}
          isLoading={reportLoading}
        />
      </div>
    );
  }
}

XfinityInventoryTable.propTypes = {
  t: PropTypes.func.isRequired,
  report: PropTypes.any.isRequired,
  reportLoading: PropTypes.bool.isRequired,
  runReport: PropTypes.func.isRequired,
  setReportLoading: PropTypes.func.isRequired,
  setReportData: PropTypes.func.isRequired,
  agent: PropTypes.object.isRequired,
  goToOrderTab: PropTypes.func.isRequired,
};

XfinityInventoryTable.defaultProps = {
  reportLoading: false,
};

function mapStateToProps(state) {
  return {
    report: state.report,
    reportLoading: state.reportSettings.reportLoading,
    agent: state.agent,
  };
}

export default connect(mapStateToProps, {
  runReport,
  setReportLoading,
  setReportData,
})(withTranslation()(XfinityInventoryTable));
